import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { AdminProfile } from "@/core/types";
import { SHORT_LIVED_CACHE } from "@/lib/constants/cache";

import { adminProfileKeys } from "../keyFactory";
import { getAdminProfile } from "../queryFunctions/getAdminProfile";

type UseAdminProfileProps<TData = AdminProfile> = {
  enabled?: boolean;
  select?: (data: AdminProfile) => TData;
};

type AdminProfileQueryOptions = UseQueryOptions<
  AdminProfile,
  unknown,
  AdminProfile,
  ReturnType<typeof adminProfileKeys.details>
>;

function optionFactory() {
  return {
    queryFn: getAdminProfile,
    queryKey: adminProfileKeys.details(),
    staleTime: SHORT_LIVED_CACHE,
  } satisfies AdminProfileQueryOptions;
}

export function useAdminProfile<TData = AdminProfile>({
  enabled,
  select,
}: UseAdminProfileProps<TData> = {}) {
  return useQuery({ ...optionFactory(), enabled, select });
}
